//Libraries
import React, { FunctionComponent } from 'react'
import GoogleMapReact from 'google-map-react'

//Types
import { GoogleMapTypes } from '../z_components-types'

//Styles
import styles from './css/googleMap.module.scss'

//Static
import googleMarker from '../../../static/google-maps-marker/red-circle.webp'

const Marker: FunctionComponent<GoogleMapTypes> = ({ address, title }) => (
  <>
    <img
      className={styles.marker}
      src={googleMarker}
      alt="Google image marker"
    />
    <p className={styles.text}>{title && title}{title && <br />}{address}</p>
  </>
)

const GoogleMap: FunctionComponent<GoogleMapTypes> = ({
  lat,
  lng,
  address,
  title,
}) => {
  return (
    <div className={styles.googleMap}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_API_KEY ?? '' }}
        defaultCenter={{ lat: lat, lng: lng }}
        defaultZoom={16}
      >
        <Marker lat={lat} lng={lng} address={address} title={title} />
      </GoogleMapReact>
    </div>
  )
}

export default GoogleMap
